<template xmlns="http://www.w3.org/1999/html">
  <b-modal size="xl" v-model="show" centered :title="createShort ? 'Auftrag beplanen' : createSubTour ? 'Tour anlegen' : 'Auftrag annehmen'"
  >
    <b-row v-if="!createShort && !createSubTour">
      <b-col md="2" class="my-auto">
          <span>Auftrag-Grp.</span>
      </b-col>
      <b-col @click="onChangeAufisn">
        <b-form-input class="form-control text-black"
                            v-model="augrNameInt"
                            :style="redBorder"
                            disabled
        ></b-form-input>
      </b-col>
    </b-row>
    <b-row class="mt-2" v-if="!createShort && !createSubTour">
      <b-col md="2" class="my-auto">
        <span>Auftrag-Wo</span>
      </b-col>
      <b-col md="2" class="my-auto pr-0" @click="onChangeAufisn">

        <b-form-input class="form-control text-black"
                      v-model="auftragInt.gi_aufisn"
                      :style="redBorder"
                      disabled
        ></b-form-input>
      </b-col>
      <b-col>
        <b-input-group @click="onChangeAufisn">
          <template #append>
            <edit-icon @click="onChangeAufisn" title="" v-tooltip="'Anpassen'" class="icon-1_5x" fillColor="#2463ea" style="cursor: pointer; color: #2463ea; margin-left: 4px;margin-bottom: 2px;" :size="72"></edit-icon>
          </template>
        <b-form-input class="form-control text-black"
                      v-model="auftragInt.gi_match"
                      disabled
                      :style="redBorder"
                      ></b-form-input>
        </b-input-group>
      </b-col>
    </b-row>
    <b-row class="mt-2" v-if="isEinzel && !createShort && !createSubTour">
      <b-col md="2" class="my-auto">
        <span>Auftraggeber</span>
      </b-col>
      <b-col>
        <b-input-group @click="$refs.a_geber_dialog.showModal()">
          <template #append>
            <edit-icon @click="$refs.a_geber_dialog.showModal()" title="" v-tooltip="'Anpassen'" class="icon-1_5x" fillColor="#2463ea" style="cursor: pointer; color: #2463ea; margin-left: 4px;margin-bottom: 2px;" :size="72"></edit-icon>
          </template>
        <b-form-input class="form-control text-black"
                      v-model="aGeber"
                      disabled
                      style="cursor: pointer"
                      ></b-form-input>
        </b-input-group>
      </b-col>
    </b-row>
    <b-row class="mt-2" v-if="!createShort">
      <b-col md="2" class="my-auto">
        <span>{{createSubTour ? 'Tourname' : 'Auftrag-Was'}}</span>
      </b-col>
      <b-col>
        <b-form-input class="form-control text-black"
                      v-model="auftragInt.gi_auf_ext"
                      ></b-form-input>
      </b-col>
    </b-row>
    <b-row class="mt-2" v-if="!createShort">
      <b-col md="2" class="my-auto">
        <span>Hinweis</span>
      </b-col>
      <b-col>
        <b-form-textarea class="text-black"
                         style="-webkit-print-color-adjust: exact !important;color-adjust: exact !important; color: black !important;"
                         rows="4"
                         no-resize
                         wrap="hard"
                         v-model="auftragInt.gi_memo"

        ></b-form-textarea>
      </b-col>
    </b-row>
    <b-row class="mt-2" v-if="!createShort && !createSubTour">
      <b-col md="2" class="my-auto">
        <span>Annahmenachricht</span>
      </b-col>
      <b-col>
        <b-form-textarea class="text-black"
                         style="-webkit-print-color-adjust: exact !important;color-adjust: exact !important; color: black !important;"
                         rows="3"
                         no-resize
                         v-model="acceptMessage"
                         wrap="hard"
        ></b-form-textarea>
      </b-col>
    </b-row>
    <b-row class="mt-2" v-if="createSubTour">
      <b-col md="2" class="my-auto">
        <span>Leistungsgr.</span>
      </b-col>
      <b-col>
        <b-input-group @click="onChangeLegr">
          <template #append>
            <edit-icon @click="onChangeLegr" title="" v-tooltip="'Anpassen'" class="icon-1_5x" fillColor="#2463ea" style="cursor: pointer; color: #2463ea; margin-left: 4px;margin-bottom: 2px;" :size="72"></edit-icon>
          </template>
          <b-form-input class="form-control text-black"
                        :style="legr.name === '' ? 'border-color: red; cursor: pointer;' : 'cursor: pointer;'"
                        v-model="legr.name"
                        disabled
          ></b-form-input>
        </b-input-group>
      </b-col>
    </b-row>

    <b-row class="mt-2" v-if="!createShort">
      <b-col class="my-auto">
        <span style="text-decoration: underline"><b>Betriebsintern</b></span>
      </b-col>
      <b-col>
      </b-col>
    </b-row>
    <b-row class="mt-2" v-if="!createShort && !createSubTour">
      <b-col>
        <b-row>
          <b-col md="4" class="my-auto">
            <span>Leistungsgr.</span>
          </b-col>
          <b-col>
            <b-input-group @click="onChangeLegr">
              <template #append>
                <edit-icon @click="onChangeLegr" title="" v-tooltip="'Anpassen'" class="icon-1_5x" fillColor="#2463ea" style="cursor: pointer; color: #2463ea; margin-left: 4px;margin-bottom: 2px;" :size="72"></edit-icon>
              </template>
              <b-form-input class="form-control text-black"
                            :style="legr.name === '' ? 'border-color: red; cursor: pointer;' : 'cursor: pointer;'"
                            v-model="legr.name"
                            disabled
              ></b-form-input>
            </b-input-group>
          </b-col>
        </b-row>
        <b-row class="mt-2">
          <b-col md="4" class="my-auto">
            <span>Auftrag-Wann</span>
          </b-col>
          <b-col>
            <b-form-select :options="s_select" id="status" :plain="true"
                           v-model="status"
                           class="mb-2 text-black"></b-form-select>
          </b-col>
        </b-row>
      </b-col>
      <b-col>
        <b-row>
          <b-col md="4" class="my-auto">
            <span>Zieldatum</span>
          </b-col>
          <b-col>
            <datetime
                style="-webkit-print-color-adjust: exact !important;color-adjust: exact !important;"

                v-model="auftragInt.ziel_datum"
                input-class="form-control"
                :input-style="auftragInt.ziel_datum === null || auftragInt.ziel_datum === '' ? 'border-color: red;' : 'color: black;'"
                input-id="date"
                :aria-placeholder="formateDate"
                :phrases="datetimeConfig.phrases"
                :format="{ day: '2-digit', month: '2-digit', year: 'numeric'}"
                :min-datetime="datetimeConfig.minTime"></datetime>
          </b-col>
        </b-row>
        <b-row class="mt-2">
          <b-col md="4" class="my-auto">
            <span>Fertigstellungsart</span>
          </b-col>
          <b-col>
            <b-form-select :options="close_automatic_select" id="close_automatic" :plain="true"
                           v-model="close_automatic"
                           class="mb-2 text-black"></b-form-select>
          </b-col>
        </b-row>
        <b-row class="mt-2"  v-if="!createShort && !createSubTour">
          <b-col md="4" class="my-auto">
            <span>Versandart</span>
          </b-col>
          <b-col v-if="taskSendType !== 'S'" md="2">
            <b-form-input class="form-control text-black"
                          v-model="taskSendInterval"
                          type="number"
                          min="1"
                          step="1"
                          @keydown="preventDecimals"
            ></b-form-input>
          </b-col>
          <b-col>
            <b-form-select :options="taskSendTypes" :plain="true"
                           v-model="taskSendType"
                           class="mb-2 text-black"></b-form-select>
          </b-col>
        </b-row>
        <b-row v-if="!createShort && !createSubTour" style="margin-left: 0px; margin-right: 0px">
          <p style="font-size: 12px; color: dimgrey; margin: 0">Gibt an wann die Aufgaben, in relation zum Zieldatum, an das mobile Gerät übertragen werden.</p>
        </b-row>
      </b-col>
    </b-row>
    <b-row class="mt-2" v-if="createShort || createSubTour">
      <b-col>
        <b-row class="mt-2">
          <b-col md="4" class="my-auto">
            <span>Zieldatum</span>
          </b-col>
          <b-col>
            <datetime
                style="-webkit-print-color-adjust: exact !important;color-adjust: exact !important;"

                v-model="auftragInt.ziel_datum"
                input-class="form-control"
                :input-style="auftragInt.ziel_datum === null || auftragInt.ziel_datum === '' ? 'border-color: red;' : 'color: black;'"
                input-id="date"
                :aria-placeholder="formateDate"
                :phrases="datetimeConfig.phrases"
                :format="{ day: '2-digit', month: '2-digit', year: 'numeric'}"
                :min-datetime="datetimeConfig.minTime"></datetime>
          </b-col>
        </b-row>
      </b-col>
      <b-col>
        <b-row class="mt-2">
          <b-col md="4" class="my-auto">
            <span>Fertigstellungsart</span>
          </b-col>
          <b-col>
            <b-form-select :options="close_automatic_select" id="close_automatic" :plain="true"
                           v-model="close_automatic"
                           class="mb-2 text-black"></b-form-select>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
    <b-row class="mt-2">
      <b-col class="my-auto">
        <span>Verantwortlich / Abrechnend</span>
      </b-col>
      <b-col>
        <b-row>
          <b-col md="8" class="my-auto">
            <span>Ausführend: Mitarbeiter / Gruppen</span>
          </b-col>

          <b-col md="4">
            <b-row style="flex-direction: row-reverse; margin-right: 8px">
              <pencil-plus-icon title="" v-tooltip="'Anpassen'" class="icon-1_5x" fillColor="#2463ea" style=" cursor: pointer; color: #016d03; margin-left: 4px;margin-bottom: 2px;" :size="72" @click="$emit('change-planning', currentPlanning)"></pencil-plus-icon>
              <minus-icon title="" v-tooltip="'Entfernen'" class="icon-1_5x" fillColor="#2463ea" style="cursor: pointer; color: #2463ea; margin-left: 4px;margin-bottom: 2px;" :size="72" @click="onDeletePlanning"></minus-icon>
              <plus-icon title="" v-tooltip="'Hinzufügen'" class="icon-1_5x" fillColor="#2463ea" style="cursor: pointer; color: #2463ea; margin-left: 4px;margin-bottom: 2px;" :size="72" @click="$emit('select-planning', users)"></plus-icon>
            </b-row>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
    <b-row class="mt-2">
      <b-col md="2"></b-col>
      <b-col md="4">
        <v-jstree ref="js_tree" :allow-transition="false"
                  :style="selectedKostMigr === null ? 'flex: 1 0; border: 1px solid red; border-radius: 0.25rem;' : 'flex: 1 0; border: 1px solid #c0c0c0; border-radius: 0.25rem;'"
                  class="my-tree" :data="kostMigrs"
                  @item-click="onItemClicked"
                  show-checkbox></v-jstree>
      </b-col>
      <b-col md="6">
        <b-table striped hover selectable :items="selectedPlannings" :fields="planningFields"
                 select-mode="single"
                 selectedVariant="primary"
                 ref="group_table"
                 @row-selected="onRowSelected"
        >
          <template v-slot:cell(memo)="data" >
            <div style="display: -webkit-box;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
    overflow: hidden;">{{data.item.memo}}</div>
          </template>
        </b-table>
      </b-col>
    </b-row>
    <template #modal-footer="{ok, cancel}">
      <!-- Emulate built in modal footer ok and cancel button actions -->
      <b-button size="md" variant="primary" @click="onCancel">
        Abbrechen
      </b-button>
      <b-button size="md" :disabled="!canContinueAuftrag" variant="success" @click="onCreate">
        {{createShort || createSubTour ? 'Anlegen' : (isEinzel ? 'Einzelauftrag Anlegen' : 'Aufgabe Anlegen')}}
      </b-button>
    </template>
    <a-geber-dialog ref="a_geber_dialog" :address-data="addressData" :can-edit="true" :task-id="null" @a-geber-change="onChangedAddress"/>

  </b-modal>

</template>

<script>
import {DateTime as LuxonDateTime} from "luxon";
import {Server_URL} from "@/shared/utils";
import EditIcon from 'vue-material-design-icons/PencilCircle.vue';
import PencilPlusIcon from 'vue-material-design-icons/PencilPlus.vue';
import PlusIcon from 'vue-material-design-icons/PlusCircle.vue';
import MinusIcon from 'vue-material-design-icons/MinusCircle.vue';
import VJstree from 'vue-jstree'
import {v4} from "uuid";
import {parseTimestamp} from "@/shared/dates";
import {decryptAES, encryptAES} from "@/shared/crypto";
import AGeberDialog from "./AGeberDialog.vue"




export default {
  name: "AcceptTaskDialog",
  components: {
    EditIcon,
    PencilPlusIcon,
    PlusIcon,
    MinusIcon,
    VJstree,
    AGeberDialog
  },
  props:{
    augrName: String,
    auftrag: {
      type: Object,
      default(rawProps)  {
          return {
            ziel: null,
            ziel_datum: null,
            gi_auf_ext: "Test Sven",
            gi_match: "Forstwirtschaft",
            gi_augr: "0009",
            gi_aufisn: "000038",
            gi_memo: "Test vom Sven",
          }
      },
    },
    closeAutomaticPresets: {
      type: Object,
      default(rawProps) {
        return {
          av_close_ab: {
            value_1: "false",
          },
          av_close_bk: {
            value_1: "false",
          },
          av_close_ft: {
            value_1: "false",
          },
          av_close_gps: {
            value_1: "false",
          },
          av_close_mm: {
            value_1: "false",
          },
          av_close_sp: {
            value_1: "false",
          },
          av_close_st: {
            value_1: "false",
          }
        }
      }
    },
    bauhofStructure: {
      type: Array,
      default: () => []
    },
    createShort: {
      type: Boolean,
      default: () => false,
    },
    createSubTour: {
      type: Boolean,
      default: () => false,
    },
  },
  computed: {
    redBorder() {
      if (this.isValidAuftrag) {
        return 'cursor: pointer;';
      } else {
        return "border-color: red; cursor: pointer;"
      }
    },
    aGeber() {
      let res = "";
      if (this.gi_anrede) {
        res += this.gi_anrede + " "
      }
      if (this.gi_name1) {
        res += this.gi_name1
      }
      if (this.gi_name2) {
        res += ", " + this.gi_name2;
      }
      if (this.gi_strasse) {
        res += ", " + this.gi_strasse
      }
      if (this.gi_ort || this.gi_plz) {
        res += ", " + this.gi_plz + " " + this.gi_ort;
      }
      return res;
    },
    isValidAuftrag() {
      return this.auftragInt.gi_aufisn !== null && this.auftragInt.gi_aufisn !== ""
          && this.auftragInt.gi_augr !== null && this.auftragInt.gi_augr !== "";
    },
    canContinueAuftrag() {
      if (this.createSubTour) {
        return this.selectedKostMigr !== null
            && this.auftragInt.ziel_datum !== null && this.auftragInt.ziel_datum !== "" && this.legr.gischl !== "";
      }
      return this.createShort ? this.selectedKostMigr !== null
          && this.auftragInt.ziel_datum !== null && this.auftragInt.ziel_datum !== "": this.isValidAuftrag && this.selectedKostMigr !== null
          && this.auftragInt.ziel_datum !== null && this.auftragInt.ziel_datum !== ""
          && this.legr.gischl !== "";
    },
    canContinueAufgabe() {
      return this.isValidAuftrag && this.selectedKostMigr !== null
          && this.auftragInt.ziel_datum !== null && this.auftragInt.ziel_datum !== "" && this.legr.gischl !== "";
      return false;
    },
    auftragDate() {
      return this.auftragInt.ziel_datum;
    }
  },
  data: () => {
    return {
      show: false,
      auftragInt: {
        ziel: null,
        ziel_datum: null,
        gi_auf_ext: "Test Sven",
        gi_match: "Forstwirtschaft",
        gi_augr: "0009",
        gi_aufisn: "000038",
        gi_memo: "Test vom Sven",
      },
      augrNameInt: "",
      datetimeConfig: {phrases: {ok: 'Ok', cancel: 'Abbruch'}, minTime: LuxonDateTime.local().toISO()},
      legr: {
        name: "",
        gischl: "",
      },
      status: -1,
      s_select: [{text: "", value: -1}, {text: "10 Monate", value: 10}, {text: "3 Monate", value: 3}, {text: "1 Monat", value: 1}, {text: "1 Woche", value: 0.25}, {text: "sofort", value: 0}],
      close_automatic: false,
      close_automatic_select: [{text: "Manuelle Fertigstellung", value: false}, {text: "Automatische Fertigstellung", value: true}],
      gelegentlich: false,
      kostMigrs : [],
      selectedKostMigr: null,
      users: [],
      selectedPlannings: [],
      currentPlanning: null,
      acceptMessage: "",
      acceptMessageMmDefault: "Ihre Mängelmeldung wird nun bearbeitet.\nSobald der Mangel behoben wurde wird Ihnen eine Fertigstellungsmeldung zugesandt.",
      planningFields: [{key: "name", label: 'Name'}, {key: "dueDate", label: "Ziel", formatter:  (value, key, item) => {
          if (!value) {
            return ""
          } else {
            return  parseTimestamp(new Date(Date.parse(value)), 'DD.MM.YYYY');
          }
        }}, {key: "memo",label: "Aufgabentext"}],
      addressData: {
        gi_anrede: '',
        gi_name1: '',
        gi_name2: '',
        gi_strasse: '',
        gi_plz: '',
        gi_ort: '',

        re_anrede: '',
        renr: '',
        re_vorname: '',
        re_name1: '',
        re_str_hnr: '',
        re_land: '',
        re_plz: '',
        re_ort: '',
      },
      a_geber: '',
      gi_anrede: '',
      gi_name1: '',
      gi_name2: '',
      gi_strasse: '',
      gi_plz: '',
      gi_ort: '',

      re_anrede: '',
      renr: '',
      re_vorname: '',
      re_name1: '',
      re_str_hnr: '',
      re_land: '',
      re_plz: '',
      re_ort: '',
      isEinzel: false,
      taskSendInterval: "2",
      taskSendType: "S",
      taskSendTypes: [
        {text: "Sofort", value: "S"}, {text: "Tage vorher", value: "D"}, {text: "Wochen vorher", value: "W"}],
    }
  },
  watch: {
    bauhofStructure(n, o) {
      if (!n || !n.length) {
        return;
      }
      this.kostMigrs = this.computeKostMigrs(JSON.parse(JSON.stringify(n)));
      this.users = JSON.parse(JSON.stringify(n));
      this.computeMitas(this.users);
    },
    status(n, o) {
      if (n === -1) {
        this.auftragInt.ziel_datum = this.auftrag.ziel_datum;
        return;
      }
      if (n === 0) {
        this.auftragInt.ziel_datum = new Date().toISOString();
      } else if (n === 0.25) {
        let d = new Date();
        d.setDate(d.getDate() + 7);
        this.auftragInt.ziel_datum = d.toISOString();
      } else {
        let d = new Date();
        d.setMonth(d.getMonth() + n);
        this.auftragInt.ziel_datum = d.toISOString();
      }
    },
    auftragDate(n, o) {
      for (let i = 0; i < this.selectedPlannings.length; i++) {
        if (!this.selectedPlannings[i].dueDate) {
          this.selectedPlannings[i].dueDate = n;
        }
      }
    }
  },
  methods: {
    preventDecimals(evt) {
      if (['.', 'e', 'E', '+', '-'].includes(evt.key) || (this.taskSendInterval === "" && evt.key === "0")) {
        evt.preventDefault();
      }
    },
    getReturnData() {
      let res = {
        gi_augr: this.auftragInt.gi_augr,
        gi_aufisn: this.auftragInt.gi_aufisn,
        gi_match: this.auftragInt.gi_match,
        gi_auf_ext: this.auftragInt.gi_auf_ext,
        gi_memo: this.auftragInt.gi_memo,
        gi_memo_plain: this.auftragInt.gi_memo,
        selected_kost: this.selectedKostMigr.id,
        selected_legr: this.legr.gischl,
        ziel_datum: this.auftragInt.ziel_datum,
        todos: this.selectedPlannings,
        accept_note_plain: this.acceptMessage,
        close_automatic: this.close_automatic,
      }
      if (!this.createShort && !this.createSubTour) {
        this.$cookies.set("task_send_type", this.taskSendType);
        if (this.taskSendType !== "S" && this.taskSendInterval !== "") {
          this.$cookies.set("task_send_interval", this.taskSendInterval);
        }
        let interval = parseInt(this.taskSendInterval, 10);
        if ((this.taskSendType === "W" || this.taskSendType === "D" && interval > 0) && !isNaN(interval)) {
          let d = new Date(res.ziel_datum.replace('Z', ''));
          d.setHours(12)
          if (this.taskSendType === "W") {
            d.setDate(d.getDate() - interval * 7);
          } else if (this.taskSendType === "D") {
            d.setDate(d.getDate() - interval);
          }
          let current = new Date();
          current.setHours(13)
          if (d > current) {
            res.send_task_date = d.toISOString().substring(0, 10);
          }
        }
      }

      return res;
    },
    onChangedAddress(data) {
      this.addressData = {...data.a_geber_data, ...data.invoice_data};
      this.gi_anrede = data.a_geber_data.gi_anrede;
      this.gi_name1 = data.a_geber_data.gi_name1;
      this.gi_name2 = data.a_geber_data.gi_name2;
      this.gi_strasse = data.a_geber_data.gi_strasse;
      this.gi_plz = data.a_geber_data.gi_plz;
      this.gi_ort = data.a_geber_data.gi_ort;
      this.re_anrede = data.invoice_data.re_anrede;
      this.renr = data.invoice_data.renr;
      this.re_vorname = data.invoice_data.re_vorname;
      this.re_name1 = data.invoice_data.re_name1;
      this.re_str_hnr = data.invoice_data.re_str_hnr;
      this.re_land = data.invoice_data.re_land;
      this.re_plz = data.invoice_data.re_plz;
      this.re_ort = data.invoice_data.re_ort;
    },
    formateDueDate(value) {
      if (!value) {
        return ""
      } else {
        return parseTimestamp(new Date(Date.parse(value)), 'DD.MM.YYYY');
      }
    },
    onRowSelected(data) {
      if (data.length) {
        this.currentPlanning = data[0];
      } else {
        this.currentPlanning = null;
      }
    },
    onNewPlanning(selected) {
      for (let i = 0; i < selected.length; i++) {
        let cur = selected[i];
        cur._id = v4();
        cur.memo = this.auftragInt.gi_memo;
        cur.dueDate = this.auftragInt.ziel_datum;
        this.selectedPlannings.push(cur);
      }
    },
    onDeletePlanning() {
      if (!this.currentPlanning) {
        return;
      }
      for (let i = 0; i < this.selectedPlannings.length; i++) {
        if (this.selectedPlannings[i]._id === this.currentPlanning._id) {
          this.selectedPlannings.splice(i, 1);
        }
      }
      this.currentPlanning = null;
    },
    onItemClicked(node, item, e) {
      this.selectedKostMigr = item;
    },
    async onCreate() {
      let data = this.getReturnData();
      if (this.gi_name1 || this.gi_name2 || this.gi_strasse) {
        data.a_geber_data = {
          gi_anrede: this.gi_anrede,
          gi_name1: this.gi_name1,
          gi_name2: this.gi_name2,
          gi_strasse: this.gi_strasse,
          gi_plz: this.gi_plz,
          gi_ort: this.gi_ort,
        };
        data.a_geber_data.gi_name1 = await encryptAES(sessionStorage.getItem("aes"), data.a_geber_data.gi_name1);
        data.a_geber_data.gi_name2 = await encryptAES(sessionStorage.getItem("aes"), data.a_geber_data.gi_name2);
        data.a_geber_data.gi_strasse = await encryptAES(sessionStorage.getItem("aes"), data.a_geber_data.gi_strasse);
      }
      if (this.renr || this.re_vorname || this.re_name1 || this.re_str_hnr){
        data.invoice_data = {
          re_anrede: this.re_anrede,
          renr: this.renr,
          re_vorname: this.re_vorname,
          re_name1: this.re_name1,
          re_str_hnr: this.re_str_hnr,
          re_land: this.re_land,
          re_plz: this.re_plz,
          re_ort: this.re_ort,
        }
        data.invoice_data.re_vorname = await encryptAES(sessionStorage.getItem("aes"), data.invoice_data.re_vorname);
        data.invoice_data.re_name1 = await encryptAES(sessionStorage.getItem("aes"), data.invoice_data.re_name1);
        data.invoice_data.re_str_hnr = await encryptAES(sessionStorage.getItem("aes"), data.invoice_data.re_str_hnr);
      }
      data.accept_task = this.isEinzel ? 'Auftrag' :  'Aufgabe';
      this.$emit('accept-task', data);
      this.show = false;
    },
    onCancel() {
      this.show = false;
    },
    async showDialog(addressData, isEinzel) {
      let taskSendType = this.$cookies.get("task_send_type");
      if (taskSendType) {
        this.taskSendType = taskSendType;
      }
      if (this.taskSendType !== "S") {
        let taskSendInterval = this.$cookies.get("task_send_interval");
        if (taskSendInterval) {
          this.taskSendInterval = taskSendInterval;
        }
      }
      if (!this.createSubTour) {
        this.addressData = JSON.parse(JSON.stringify(addressData));

        this.gi_anrede = this.addressData.gi_anrede;
        try {
          this.gi_name1 = await decryptAES(sessionStorage.getItem("aes"), this.addressData.gi_name1)
        } catch (e) {
          this.gi_name1 = this.addressData.gi_name1
        }
        try {
          this.gi_name2 = await decryptAES(sessionStorage.getItem("aes"), this.addressData.gi_name2)
        } catch (e) {
          this.gi_name2 = this.addressData.gi_name2
        }
        try {
          this.gi_strasse = await decryptAES(sessionStorage.getItem("aes"), this.addressData.gi_strasse)
        } catch (e) {
          this.gi_strasse = this.addressData.gi_strasse
        }
        this.gi_plz = this.addressData.gi_plz
        this.gi_ort = this.addressData.gi_ort

        this.re_anrede = this.addressData.re_anrede;
        this.renr = this.addressData.renr;
        try {
          this.re_vorname = await decryptAES(sessionStorage.getItem("aes"), this.addressData.re_vorname)
        } catch (e) {
          this.re_vorname = this.addressData.re_vorname
        }
        try {
          this.re_name1 = await decryptAES(sessionStorage.getItem("aes"), this.addressData.re_name1)
        } catch (e) {
          this.re_name1 = this.addressData.re_name1
        }
        try {
          this.re_str_hnr = await decryptAES(sessionStorage.getItem("aes"), this.addressData.re_str_hnr)
        } catch (e) {
          this.re_str_hnr = this.addressData.re_str_hnr
        }
        this.re_land = this.addressData.re_land;
        this.re_plz = this.addressData.re_plz;
        this.re_ort = this.addressData.re_ort;
      }
      this.isEinzel = isEinzel;
      this.auftragInt = JSON.parse(JSON.stringify(this.auftrag));
      if (this.createShort) {
        this.auftragInt.gi_memo = this.auftragInt.memo;
      }
      this.augrNameInt = this.augrName;
      this.legr = {
        name: "",
        gischl: "",
      };
      this.gelegentlich = false;
      this.status = -1
      if (!this.createSubTour) {
        if (this.auftragInt.modul === "mm") {
          this.acceptMessage = this.acceptMessageMmDefault;
        }
        switch (this.auftragInt.modul) {
          case "mm":
            this.close_automatic = this.closeAutomaticPresets["av_close_mm"].value_1 === "true";
            break;
          case "ab":
            this.close_automatic = this.closeAutomaticPresets["av_close_ab"].value_1 === "true";
            break;
          case "bk":
            this.close_automatic = this.closeAutomaticPresets["av_close_bk"].value_1 === "true";
            break;
          case "ft":
            this.close_automatic = this.closeAutomaticPresets["av_close_ft"].value_1 === "true";
            break;
          case "k5":
            this.close_automatic = this.closeAutomaticPresets["av_close_ft"].value_1 === "true";
            break;
          case "k1":
            this.close_automatic = this.closeAutomaticPresets["av_close_sp"].value_1 === "true";
            break;
          case "k3":
            this.close_automatic = this.closeAutomaticPresets["av_close_st"].value_1 === "true";
            break;
          case "k4":
            this.close_automatic = this.closeAutomaticPresets["av_close_gps"].value_1 === "true";
            break;
        }
      } else {
        this.close_automatic = true;
      }
      this.show = true;
    },
    formateDate() {
      if (this.auftragInt.ziel_datum === null) {
        return ""
      }
      let event = new Date(this.auftragInt.ziel_datum.replace('Z', ''));
      let options = {year: 'numeric', month: '2-digit', day: '2-digit'};
      return event.toLocaleDateString('de-DE', options);
    },
    onChangeAufisn() {
      this.$emit("select-aufisn");
    },
    onSetAufisn(data) {
      this.auftragInt.gi_aufisn = data.selected_aufisn.gi_aufisn;
      this.auftragInt.gi_augr = data.selected_aufisn.gi_augr;
      this.auftragInt.gi_match = data.selected_aufisn.gi_match;
      this.augrNameInt = data.selected_augr.titel;
    },
    onChangeLegr() {
      this.$emit("select-legr");
    },
    onSetLegr(legr) {
      this.legr = legr.selected_legr
    },
    computeKostMigrs(data) {
      data.sort((a,b) => (a.text.toLowerCase() > b.text.toLowerCase()) ? 1 : ((b.text.toLowerCase() > a.text.toLowerCase()) ? -1 : 0));
      let res = [];
      for (let i = 0; i < data.length; i++) {
        if (data[i].node_type !== "user") {
          let cur = {...data[i]}
          cur.children = this.computeKostMigrs(cur.children)
          res.push(cur)
        }
      }
      return res;
    },
    computeMitas(data) {
      for (let i = 0; i < data.length; i++) {
        if (data[i].node_type === "user") {
          let cur = {...data[i]}
          let parsed = JSON.parse(sessionStorage.getItem(cur.id));
          if (parsed) {
            cur.text = parsed.full_name;
          }
          data[i] = cur;
        } else {
          this.computeMitas(data[i].children)
        }
      }
      data.sort((a,b) => (a.text.toLowerCase() > b.text.toLowerCase()) ? 1 : ((b.text.toLowerCase() > a.text.toLowerCase()) ? -1 : 0));
    },
    onChangeTodo(data) {
      for (let i = 0; i < this.selectedPlannings.length; i++) {
        if (this.selectedPlannings[i]._id === data._id) {
          this.selectedPlannings[i] = data;
          this.selectedPlannings = [...this.selectedPlannings]
        }
      }
      this.currentPlanning = null;
    }
  }


}
</script>

<style>
.form-control:disabled, .form-control[disabled] {
  color: black !important;
}

.text-black {
  color: black;
}
</style>

<style scoped>

.my-tree {
  max-height: calc(30vh - 70px);
  overflow: auto;
}

</style>
